define('lq/events/actions/copyDynamicContentCommand',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function CopyDynamicContentCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(CopyDynamicContentCommand, EventAction);

    CopyDynamicContentCommand.typeName = 'CopyDynamicContentCommand';

    CopyDynamicContentCommand.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    CopyDynamicContentCommand.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'CopyDynamicContent',
            command: this.eventData.command
        };
    };

    return CopyDynamicContentCommand;
});
